// wait for page load
jQuery(document).ready(function() {

  $dependencyManager.addDependenciesCallback(['swiper', 'hls', 'plyr'], () => {
    class HoverVideoTestimonialsSlider {
      constructor(container) {
        this.container = jQuery(container);
        this.slider = this.container.find('> .mad-slider');
        this.sliderId = this.container.data('slider-id');
        this.nextSlideSpeed = this.container.data('speed') || 1000;
        this.loopSlides = this.container.data('loop') || false;
        this.swiper = null;
        this.initSlider();

        this.players = {};
        this.videoLoader = null;
        this.initVideos();
        this.addClosePopupCallback();
      }

      initSlider() {
        const self = this;
        this.swiper = new Swiper(`.mad-slider__container--hover-video-testimonials[data-slider-id="${this.sliderId}"] .mad-slider__slides-container`, {
          direction: 'horizontal',
          loop: this.loopSlides,
          speed: this.nextSlideSpeed,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          slidesPerView: 'auto',
          spaceBetween: 10,
          updateOnWindowResize: true,
          freeMode: true,
          shortSwipes: false,
          longSwipes: false,
        });

        this.container.css('opacity', '1');

        // Desktop hover events
        this.container.find('.mad-slider__slide').hover(
          function () {
            const $video = jQuery(this).find('.mad-hover-video-testimonials__video');
            const videoSrc = $video.data('src');
            if (!videoSrc) return;
            $video.prop('muted', true);
            $video.attr('muted', 'muted');
            self.playVideo($video, videoSrc);
          },
          function () {
            const $video = jQuery(this).find('.mad-hover-video-testimonials__video');
            self.pauseVideo($video, $video.data('src'));
          }
        );

        // For mobile devices: hold to play video; quick tap to follow link.
        if (window.matchMedia("(pointer: coarse)").matches) {
          const TOUCH_HOLD_DURATION = 250;
          this.container.find('.mad-slider__slide')
            .on('touchstart', function(event) {
              const $slide = jQuery(this);
              const $video = $slide.find('.mad-hover-video-testimonials__video');
              const videoSrc = $video.data('src');
              if (!videoSrc) return;
              event.preventDefault();
              $slide.data('touchTimer', setTimeout(() => {
                self.playVideo($video, videoSrc);
                $video.data('isPlaying', true);
              }, TOUCH_HOLD_DURATION));
            })
            .on('touchend', function(event) {
              const $slide = jQuery(this);
              const $video = $slide.find('.mad-hover-video-testimonials__video');
              const videoSrc = $video.data('src');
              if (!videoSrc) return;
              const touchTimer = $slide.data('touchTimer');
              if (touchTimer) {
                clearTimeout(touchTimer);
                $slide.removeData('touchTimer');
              }
              if ($video.data('isPlaying')) {
                self.pauseVideo($video, videoSrc);
                $video.data('isPlaying', false);
              } else {
                const button = $slide.find('.mad-hover-video-testimonials__play-btn')[0];
                if (button) {
                  button.click();
                }
              }
            });
        }
      }

      // Common playVideo method; reuses same logic as in the hover slider.
      playVideo($video, videoSrc) {
        $video.prop('muted', true);
        $video.attr('muted', 'muted');
        const startTime = parseInt($video.data('start-time')) || 0;

        if (videoSrc.endsWith('.mp4')) {
          if ($video.attr('src') !== videoSrc) {
            $video.attr('src', videoSrc);
          }
          $video[0].play().then(() => {
          }).catch(error => {
          });
        } else if (videoSrc.endsWith('.m3u8')) {
          if (!$video.data('player')) {
            const player = new Plyr($video[0], {
              iconUrl: window.madPlyrIconUrl,
              controls: [],
              muted: true,
              autoplay: false,
              loop: { active: true },
              fullscreen: { enabled: false },
              playsinline: true,
              storage: { enabled: false }
            });
            $video.data('player', player);
    
            if (Hls.isSupported()) {
              const hls = new Hls({
                startLevel: 2,
                maxBufferLength: 5,
                maxMaxBufferLength: 10,
                maxBufferSize: 5 * 1000 * 1000,
                maxBufferHole: 0.5,
                lowLatencyMode: true,
                startPosition: startTime,
              });
              hls.loadSource(videoSrc);
              hls.attachMedia($video[0]);
              hls.on(Hls.Events.MANIFEST_PARSED, () => {
                player.play().then(() => {
                  if (startTime > 0) {
                    player.currentTime = startTime;
                  }
                }).catch(error => {});
              });
              $video.data('hls', hls);
            } else if ($video[0].canPlayType('application/vnd.apple.mpegurl')) {
              $video[0].src = videoSrc;
              player.play();
            }
          } else {
            const player = $video.data('player');
            const hls = $video.data('hls');
            if (hls && typeof hls.startLoad === 'function') {
              hls.startLoad();
            }
            player.play().then(() => {
              if (startTime > 0) {
                player.currentTime = startTime;
              }
            }).catch(error => {});
          }
        }
      }

      // Common pauseVideo method
      pauseVideo($video, videoSrc) {
        if (!videoSrc) return;

        if (videoSrc.endsWith('.mp4')) {
          $video[0].pause();
        } else if (videoSrc.endsWith('.m3u8')) {
          const player = $video.data('player');
          if (player) {
            player.pause();
          }
          const hls = $video.data('hls');
          if (hls && typeof hls.stopLoad === 'function') {
            hls.stopLoad();
          }
        }
      }

      pauseHoverVideos() {
        this.container.find('.mad-hover-video-testimonials__video').each((index, el) => {
          const $video = jQuery(el);
          const player = $video.data('player');
          if (player) {
            player.pause();
          } else if (el.pause) {
            el.pause();
          }
          const hls = $video.data('hls');
          if (hls && typeof hls.stopLoad === 'function') {
            hls.stopLoad();
          }
        });
      }

      initVideos() {
        this.container.find('.mad-hover-video-testimonials__play-btn').each((index, button) => {
          const $button = jQuery(button);
          const uniqueId = this.generateUniqueId();

          if ($button.data('video-url')) {
            $button.data('unique-id', uniqueId);
            
            const $video = $button.closest('.mad-slider__slide').find('.mad-hover-video-testimonials__video');
            const startTime = $video.data('start-time') || 0;
            $button.data('start-time', startTime);

            $button.click(() => {  
              if ($button.data('isLoading')) return;
              $button.data('isLoading', true);
              let videoUrl = $button.data('video-url');
              let container = jQuery('.mad-popup-video__container .brz-column__items');

              if (container.find(`.mad-video-testimonial__container[data-unique-id="${uniqueId}"]`).length === 0) {
                this.loadVideo(container, videoUrl, uniqueId);
              }

              this.pauseHoverVideos();

              this.showVideo(uniqueId);

              window.openBrizyPopupByChild('.mad-popup-video__container');

              setTimeout(() => {
                $button.data('isLoading', false);
              }, 1000);
            });
          }
        });
      }

      loadVideo(container, videoUrl, uniqueId) {
        container.find('.mad-video-testimonial__container').hide();
      
        const videoContainer = jQuery('<div>', {
          class: 'mad-video-testimonial__container',
          'data-unique-id': uniqueId,
          css: {
            display: 'none'
          }
        });
      
        const videoWrapper = jQuery('<div>', {
          class: 'mad-video-testimonial'
        });
      
        videoContainer.append(videoWrapper);
        container.append(videoContainer);
      
        const videoElement = jQuery('<video>', {
          class: 'plyr',
          controls: true
        });
      
        videoWrapper.append(videoElement);
      
        if (videoUrl.endsWith('.mp4')) {
          // MP4 logic: set src directly and play when metadata is loaded.
          videoElement.attr('src', videoUrl);
          videoElement[0].addEventListener('loadedmetadata', () => {
            this.playWithSound(this.players[uniqueId] || videoElement[0]);
          });
        } else if (Hls.isSupported()) {
          const hls = new Hls({ startLevel: 2,
            maxBufferLength: 20,
            maxMaxBufferLength: 60,
            maxBufferSize: 60 * 1000 * 1000,
            maxBufferHole: 0.5,
          });
          hls.loadSource(videoUrl);
          hls.attachMedia(videoElement[0]);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            this.playWithSound(this.players[uniqueId] || videoElement[0]);
          });
          videoElement.data('hls', hls);
        } else if (videoElement[0].canPlayType('application/vnd.apple.mpegurl')) {
          // Fallback for native HLS support.
          videoElement[0].src = videoUrl;
          videoElement[0].addEventListener('loadedmetadata', () => {
            this.playWithSound(this.players[uniqueId] || videoElement[0]);
          });
        }

        // Quality Mappings of Bunny CDN - https://dash.bunny.net/stream/.../encoding
        const qualityMapping = { '240': 0, '360': 1, '480': 2, '720': 3, '1080': 4, /*'1440': 5, '2160': 6*/};

        const player = new Plyr(videoElement[0], {
          iconUrl: window.madPlyrIconUrl,
          muted: false,
          volume: 0.5,
          autoplay: true,
          loop: { active: true },
          settings: ['quality', 'speed'],
          storage: { enabled: false },
          quality: {
            default: '720',
            options: Object.keys(qualityMapping).reverse(),
            forced: true,
            onChange: (newQuality) => {
              const hls = videoElement.data('hls');
              if (hls) {
                hls.currentLevel = qualityMapping[newQuality];
              }
            }
          }
        });
        player.on('ready', () => {
          player.muted = false;
          player.volume = 0.5;
        });

        this.players[uniqueId] = player; // Map uniqueId to player
      }

      showVideo(uniqueId) {
        jQuery('.mad-video-testimonial__container').hide();
        jQuery(`.mad-video-testimonial__container[data-unique-id="${uniqueId}"]`).show();

        // Play the video automatically
        if (this.players[uniqueId]) {
          this.playWithSound(this.players[uniqueId]);
        }
      }

      playWithSound(player) {
        player.muted = false;
        player.volume = 0.5;

        const result = player.play();
        if (result && typeof result.catch === 'function') {
          result.catch(() => {
            player.muted = true;
            const retry = player.play();
            if (retry && typeof retry.catch === 'function') retry.catch(() => {});
          });
        }
      }

      generateUniqueId() {
        return '_' + Math.random().toString(36).slice(2, 11);
      }

      killMedia(media) {
        if (!media) return;
        try {
          media.pause();
          media.autoplay = false;
          media.muted = true;
          media.removeAttribute('autoplay');
          media.removeAttribute('src');
          media.srcObject = null;
          media.load();
        } catch (e) {}
      }

      stopAllVideos() {
        const active = document.activeElement;
        if (active && typeof active.blur === 'function' && jQuery(active).closest('.brz-popup2, .brz-popup').length) {
          active.blur();
        }

        Object.entries(this.players).forEach(([uniqueId, player]) => {
          const $container = jQuery(`.mad-video-testimonial__container[data-unique-id="${uniqueId}"]`);
          const hls = $container.find('video').data('hls');

          if (hls) {
            try {
              hls.stopLoad();
              hls.detachMedia();
              hls.destroy();
            } catch (e) {}
          }

          if (player) {
            try {
              player.pause();
              if (typeof player.destroy === 'function') {
                player.destroy();
              }
            } catch (e) {}
            this.killMedia(player.media);
          }

          $container.find('video, audio').each((index, media) => this.killMedia(media));

          $container.remove();

          delete this.players[uniqueId];
        });

        jQuery('.mad-popup-video__container').find('video, audio').each((index, media) => {
          if (!media.paused) {
            this.killMedia(media);
          }
        });
      }

      addClosePopupCallback() {
        const popup = jQuery('.mad-popup-video__container').closest('.brz-popup2');
        const popupId = popup.data('brz-popup');
        if (popupId) {
          brizyPopupAddCloseCallback(popupId, () => {
            this.stopAllVideos();
          });
        }
        this.startPeriodicCheck();
      }

      startPeriodicCheck() {
        setInterval(() => {
          const id = window.getBrizyPopupIdByChild('.mad-popup-video__container');
          const isOpen = id && window.isBrizyPopupOpen(id);
          if (isOpen) return;
          if (jQuery.isEmptyObject(this.players) && !jQuery('.mad-popup-video__container').find('video, audio').filter((i, m) => !m.paused).length) {
            return;
          }
          this.stopAllVideos();
        }, 500);
      }

    }

    jQuery('.mad-slider__container--hover-video-testimonials').each(function() {
      new HoverVideoTestimonialsSlider(this);
    });
  });
});

